import { createClient } from "@supabase/supabase-js";

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || "").trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || "").trim();

export const supabaseReady = Boolean(supabaseUrl && supabaseAnonKey);

// Silenced logs for production-ready console

export const supabase = supabaseReady
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true, // garante sessão entre reloads
        autoRefreshToken: true, // refresh automático dos tokens
        detectSessionInUrl: true, // processa fragmentos da URL após OAuth
      },
      global: {
        headers: {
          "X-Client-Info": "autocar-ai-web",
        },
      },
    })
  : ({} as ReturnType<typeof createClient>);

/**
 * Helper opcional para garantir erro claro se usado sem env.
 */
export function assertSupabaseReady() {
  if (!supabaseReady) {
    throw new Error("Supabase não inicializado: verifique VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY.");
  }
}
